import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  root: {
    border: `1px solid ${theme.palette.separator.main}`,
    backgroundColor: theme.palette.otherElementsBackground.main,
    color: theme.palette.contrastText.main,
  },
  rounded: {
    borderRadius: theme.spacing(1),
  },
  title: {
    fontSize: 21,
    lineHeight: "25px",
  },
}));
